import Http from '@/apis/http';
import { ISearchApiResult } from '@/resources/interfaces';
import { InvitationModel } from '@/resources/models';

export class InvitationApi {
  static search(query: any = {}): Promise<ISearchApiResult<InvitationModel>> {
    return Http.get('/admin/invitations', query);
  }
}
